import { createContext, useContext } from "react";

type ArticleContextType = {
  activeSection: string;
  setSection: (section: string) => void;
};

export const ArticleContext = createContext<ArticleContextType>({
  activeSection: "",
  setSection: () => {},
});

export const useArticleContext = () => {
  const context = useContext(ArticleContext);

  if (context === undefined) {
    throw new Error("useArticleContext must be used within a ArticleProvider");
  }

  return context;
};
